/**
 * El guion de «no aplica» en tablas, Excel e informes.
 *
 * La app ya lo pintaba en varios sitios (columna «Operarios» del listado de
 * recorridos, «Fecha final» de una OT abierta, Excel del RV), cada uno con su
 * literal. Vive aquí para que las celdas nuevas no inventen otro: a partir de
 * 2026-09-04 la actuación básica lo usa donde una normal enseñaría sus
 * operarios, porque la básica no tiene tripulación (es del recorrido).
 */
export const EMPTY_VALUE = '—';
